export default "__VITE_ASSET__1zwt0uyO__"